import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Preloader, ThreeDots } from "react-preloader-icon";
import Navbar from "../../components/Navbar/Navbar";
import NavigationBar from "../../components/NavigationBar/NavigationBar";
import { apiGetPromotion } from "../../services/apis/promotion";

import moment from "moment";
import "moment/locale/th";

import "antd/dist/antd.css";
import "./Promotion.css";

const Promotion = () => {
  const [listPromotion, setListPromotion] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const renderIcon = (type) => {
    switch (type) {
      case "AVAILABLE":
        return "/assets/icon-pro/1.png";
      case "UNAVAILABLE":
        return "/assets/icon-pro/2.png";
      case "USED":
        return "/assets/icon-pro/3.png";
      default:
        return "/assets/icon-pro/2.png";
    }
  };

  const getTableData = async () => {
    setIsLoading(true);
    let promotion = await apiGetPromotion();
    console.log(promotion);
    if (promotion && promotion.status) {
      setIsLoading(false);
      setListPromotion(promotion);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTableData();
  }, []);

  return (
    <div className="App">
      <Navbar />
      <div className="promotion">
        <h3 className="title-topup">โปรโมชั่น</h3>
        <div className="list-pro">
          {isLoading ? (
            <div>
              {" "}
              <Preloader
                use={ThreeDots}
                size={60}
                strokeWidth={6}
                strokeColor="#c55a59"
                duration={2000}
              />
            </div>
          ) : (
            listPromotion &&
            listPromotion.result.length > 0 &&
            listPromotion.result.map((v, i) => (
              <div
                key={i}
                className={`cov-b-pro ${v.status === "USED" ? "used" : ""}`}
              >
                <p className="name-site">{v.name}</p>
                <Row gutter={[16, 16]} align="middle" className="row-pro">
                  <Col span={6}>
                    <p className="count-pro">{v.timecount}</p>
                  </Col>
                  <Col span={12}>
                    <p className="exp-pro">
                      Exp {moment.utc(v.exp).local().format("DD/MM/YYYY")}
                    </p>
                  </Col>
                  <Col span={6}>
                    <div className="icon-pro">
                      <img
                        alt=""
                        className="logo-rabbit"
                        src={renderIcon(v.status)}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            ))
          )}
          {/* <div className='cov-b-pro'>
                        <p className='name-site'>Coupon - 10 free 1 plum condo</p>
                        <Row gutter={[16, 16]} align="middle" className='row-pro'>
                            <Col span={6}>
                                <p className='count-pro'>4 / 10</p>
                            </Col>
                            <Col span={12}>
                                <p className='exp-pro'>Exp 31/12/2022</p>
                            </Col>
                            <Col span={6}>
                                <div className='icon-pro'>
                                    <img className='logo-rabbit' src='/assets/icon-pro/2.png' />
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className='cov-b-pro'>
                        <p className='name-site'>Coupon - 6 dry free ฿10 plum condo</p>
                        <Row gutter={[16, 16]} align="middle" className='row-pro'>
                            <Col span={6}>
                                <p className='count-pro'>6 / 6</p>
                            </Col>
                            <Col span={12}>
                                <p className='exp-pro'>Exp 01/06/2022</p>
                            </Col>
                            <Col span={6}>
                                <div className='icon-pro'>
                                    <img className='logo-rabbit' src='/assets/icon-pro/1.png' />
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div className='cov-b-pro used'>
                        <p className='name-site'>Coupon - 10 free 1 plum condo</p>
                        <Row gutter={[16, 16]} align="middle" className='row-pro'>
                            <Col span={6}>
                                <p className='count-pro'>10 / 10</p>
                            </Col>
                            <Col span={12}>
                                <p className='exp-pro'>Exp 31/12/2022</p>
                            </Col>
                            <Col span={6}>
                                <div className='icon-pro'>
                                    <img className='logo-rabbit' src='/assets/icon-pro/3.png' />
                                </div>
                            </Col>
                        </Row>
                    </div> */}
        </div>
      </div>
      <NavigationBar />
    </div>
  );
};

export default Promotion;
